
// region JS Imports

// region External Modules
import $ from "jquery"
// endregion External Modules

// region Private Modules
import Modal from "app/modal/show-modal"
import q_ajax_3 from "app/utils/q_ajax/q_ajax_3"
import {
  isLocalStorageEnabled,
  setDataToLocalStorage,
} from "app/local_storages/native_api_adapter"

import * as Routes from "plugins/js-routes"
import I18n from "plugins/i18n-js"
// endregion Private Modules

// region Public Components
// endregion Public Components

// region Private Components
import {
  Factory as MonthRangeSelectMenuFactory,
} from "./../filter_bar/month_range_select_menu/index"
// endregion Private Components

// endregion JS Imports

const init = () => {
  q_ajax_3({
    url:      Routes.apps_spacious_website_partials_real_estate_transactions_dismiss_period_comparison_modal_path(
      {
        locale: I18n.locale,
      },
    ),
    method:   "GET",
    dataType: "html",
  })
  .then(({data}) => {
    Modal.hideTopModal()
    Modal.showModalWithContent(data, {
      class: "container",
    })

    const $scope = $(".cell--real-estate-transactions--partials--dismiss_period_comparison_modal")
    const $dismiss_period_comparison_cancel = $scope.find(".real_estate_transactions-page--dismiss_period_comparison_modal-content-cancel-button")
    const $dismiss_period_comparison_confirm = $scope.find(".real_estate_transactions-page--dismiss_period_comparison_modal-content-confirm-button")
    const $dismiss_period_comparison_check   = $scope.find(".real_estate_transactions-page--dismiss_period_comparison_modal-content--selection-check")

    const month_range_select_menu = MonthRangeSelectMenuFactory.instance()

    $dismiss_period_comparison_cancel.on("click", () => {
      Modal.hideAllModals()
    })

    $dismiss_period_comparison_confirm.on("click", () => {
      if ($dismiss_period_comparison_check.prop("checked")) {
        if ( isLocalStorageEnabled() ) {
          setDataToLocalStorage($dismiss_period_comparison_check.attr("id") as string, "true")
        }
      }

      Modal.hideAllModals()

      month_range_select_menu.on_duration_item_select(month_range_select_menu.get_target_duration_item("all"))
    })

  })
}


export default {init}
